import { Config } from './config';
const VALID_CURRENCIES = ['USD', 'EUR', 'SAR', 'AED', 'GBP', 'KWD', 'BHD', 'QAR', 'OMR'];
export function generateId() {
    return Math.random().toString(36).substring(2, 11);
}
export function validateAmount(amount) {
    return typeof amount === 'number' && amount > 0;
}
export function validateCurrency(currency) {
    return VALID_CURRENCIES.includes(currency.toUpperCase());
}
export function getClientToken() {
    const script = document.currentScript ||
        document.querySelector('script[data-client-token]');
    return script ? script.getAttribute('data-client-token') : null;
}
export function validateOrigin(origin) {
    const config = Config.getInstance();
    return origin === config.getMessageOrigin();
}
export function smoothScrollTo(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}
export function setupSmoothScrolling() {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = link.getAttribute('href');
            if (href && href !== '#') {
                smoothScrollTo(href.substring(1));
            }
        });
    });
}
export async function tokenize() {
    try {
        const clientToken = getClientToken();
        if (!clientToken) {
            throw new Error('Client token not found. Please add data-client-token attribute to script tag.');
        }
        const config = Config.getInstance();
        console.log('🔑 Tokenizing client token...');
        const response = await fetch(`${config.getApiBaseUrl()}/v1/tokenize`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-client-token': clientToken,
                'Origin': window.location.origin
            }
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to tokenize');
        }
        const result = await response.json();
        console.log('✅ SDK token received');
        return result.token;
    }
    catch (error) {
        console.error('❌ Tokenization error:', error);
        throw error;
    }
}
